const KeywordGraphTypes = {
    SEARCH_VOLUME: 'SEARCH_VOLUME',
    TRENDS: 'TRENDS',
};

export default KeywordGraphTypes;
